import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { allThemes } from "Components/Themes/allThemes";
import { AgreementCode } from "Store/userIdentification/agreementCodes";
import { Partner } from "./partnerInterfaces";

export const themeFromPartnerGroup = (group?: string): any => {
  switch (group) {
    case Partner.AFAG:
      return allThemes.afag;
    case Partner.LEGEFORENINGEN:
      return allThemes.legeforeningen;
    case Partner.TANNLEGEFORENINGEN:
      return allThemes.tannlegeforeningen;
    case Partner.VETERINARENE:
      return allThemes.veterinarene;
    case Partner.ECONA:
      return allThemes.econa;
    case Partner.NATURVITERNE:
      return allThemes.naturviterne;
    case Partner.LEKTORLAGET:
      return allThemes.lektorlaget;
    case Partner.PSYKOLOGFORENINGEN:
      return allThemes.psykologforeningen;
    case Partner.SAMFUNNSVITERNE:
      return allThemes.samfunnsviterne;
    case Partner.SAMFUNNSOKONOMENE:
      return allThemes.samfunnsokonomene;
    case Partner.COOP:
      return allThemes.coop;
    case Partner.DANSKE_BANK:
      return allThemes.danskebank;
    case Partner.HUSEIERNE:
      return allThemes.huseierne;
    default:
      return allThemes.stb;
  }
};

export const themeFromAgreementCode = (code?: number): any => {
  return themeFromPartnerGroup(partnerFromAgreementCode(code));
};

export const agreementFromPartnerId = (
  group: string,
): AgreementCode | undefined => {
  switch (group) {
    case Partner.AFAG:
      return AgreementCode.AFAG;
    case Partner.LEGEFORENINGEN:
      return AgreementCode.LEGEFORENINGEN;
    case Partner.TANNLEGEFORENINGEN:
      return AgreementCode.TANNLEGEFORENINGEN;
    case Partner.VETERINARENE:
      return AgreementCode.VETERINARENE;
    case Partner.ECONA:
      return AgreementCode.ECONA;
    case Partner.NATURVITERNE:
      return AgreementCode.NATURVITERNE;
    case Partner.LEKTORLAGET:
      return AgreementCode.LEKTORLAGET;
    case Partner.PSYKOLOGFORENINGEN:
      return AgreementCode.PSYKOLOGFORENINGEN;
    case Partner.SAMFUNNSVITERNE:
      return AgreementCode.SAMFUNNSVITERNE;
    case Partner.SAMFUNNSOKONOMENE:
      return AgreementCode.SAMFUNNSOKONOMENE;
    case Partner.COOP:
      return AgreementCode.COOP;
    case Partner.DANSKE_BANK:
      return AgreementCode.DANSKE_BANK;
    case Partner.HUSEIERNE:
      return AgreementCode.HUSEIERNE;
    default:
      return undefined;
  }
};

export const partnerFromAgreementCode = (agreement?: number): Partner => {
  switch (agreement) {
    case AgreementCode.AFAG:
      return Partner.AFAG;
    case AgreementCode.LEGEFORENINGEN:
      return Partner.LEGEFORENINGEN;
    case AgreementCode.TANNLEGEFORENINGEN:
      return Partner.TANNLEGEFORENINGEN;
    case AgreementCode.VETERINARENE:
      return Partner.VETERINARENE;
    case AgreementCode.ECONA:
      return Partner.ECONA;
    case AgreementCode.NATURVITERNE:
      return Partner.NATURVITERNE;
    case AgreementCode.LEKTORLAGET:
      return Partner.LEKTORLAGET;
    case AgreementCode.PSYKOLOGFORENINGEN:
      return Partner.PSYKOLOGFORENINGEN;
    case AgreementCode.SAMFUNNSVITERNE:
      return Partner.SAMFUNNSVITERNE;
    case AgreementCode.SAMFUNNSOKONOMENE:
      return Partner.SAMFUNNSOKONOMENE;
    case AgreementCode.COOP:
      return Partner.COOP;
    case AgreementCode.DANSKE_BANK:
      return Partner.DANSKE_BANK;
    case AgreementCode.HUSEIERNE:
      return Partner.HUSEIERNE;
    default:
      return Partner.STOREBRAND;
  }
};

export const isProductActivatedForPartner = (
  partnerId: Partner,
  productBackendName: ProductBackendName,
): boolean => {
  switch (partnerId) {
    case Partner.DANSKE_BANK:
      return [
        ProductBackendName.CHILD,
        ProductBackendName.DISABILITY,
        ProductBackendName.DEATH,
        ProductBackendName.CRITICAL_ILLNESS,
      ].includes(productBackendName);
    case Partner.HUSEIERNE:
      return ![ProductBackendName.HOUSE_CONTENTS].includes(productBackendName);
    default:
      return true;
  }
};
